import { render, staticRenderFns } from "./cxSlider.vue?vue&type=template&id=315f8c86&scoped=true"
import script from "./cxSlider.vue?vue&type=script&lang=js"
export * from "./cxSlider.vue?vue&type=script&lang=js"
import "./cxSlider.vue?vue&type=style&index=0&id=315f8c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f8c86",
  null
  
)

export default component.exports